import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import React from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'

import { Firebase, Game } from '../../../Core'

import * as selectors from '../ranking.selectors'
import * as tutorialSelectors from '../../../Tutorial/tutorial.selectors'

import * as mapSelectors from '../../Map/map.selectors'

import * as actions from '../ranking.actions'
import * as mapActions from '../../Map/map.actions'
import * as toastManagerActions from '../../Toast/toast.actions'
import * as audioActions from '../../../Core/Game/AudioContainer/audio.actions'
import * as tutorialActions from '../../../Tutorial/tutorial.actions'

import BasicToast from '../../Toast/BasicToast'
import Feed from '../Feed'
import Federations from '../Federations'
import MisHeader from '../../Components/MisHeader'
import MapButton from '../../Map/MapButton'
import UserShield from '../../Components/UserShield'

import * as Util from '../../Util/util'
import * as utils from '../../Ranking/ranking.utils'

const MAX_BATTLES = 2
/**
 *  Main ranking view
 */
class RankingScreen extends React.Component {
  /****/
  constructor(props) {
    super(props)
    this.state = {
      active: 'all',
      growOutClass: '',
    }
    
    // Bind methods to avoid creating new functions on each render
    this.handleLoadPlayer = this.handleLoadPlayer.bind(this)
    this.removeScreen = this.removeScreen.bind(this)
    this.handleBackToBase = this.handleBackToBase.bind(this)
  }

  // Optimize re-renders
  shouldComponentUpdate(nextProps, nextState) {
    // State changes always trigger re-render
    if (this.state !== nextState) {
      return true
    }

    // Critical props for ranking display
    const criticalProps = [
      'playersRanking', 'federationsRanking', 'currentUser',
      'visitorMap', 'filter', 'totalFeed', 'isTutorial'
    ]

    for (const prop of criticalProps) {
      if (this.props[prop] !== nextProps[prop]) {
        return true
      }
    }

    return false
  }

  componentWillUnmount() {
    const { changeFilter, backToRanking } = this.props
    changeFilter('')
    backToRanking(false)
  }

  handleLoadPlayer(uid) {
    const { loadVisitorMap, visitorMap, isTutorial, loadTutorialVisitorMap } = this.props

    if (!visitorMap.mapId) {
      if (isTutorial) {
        loadTutorialVisitorMap(uid)
      } else {
        loadVisitorMap(uid)
      }
    }

    this.removeScreen()
  }

  removeScreen() {
    const { removeScreen, removePopup, addHowlSound } = this.props

    this.setState({ growOutClass: 'bounceOut-animation' })
    addHowlSound('button_click_icon')

    setTimeout(() => {
      removePopup('tile_popup')
      removeScreen('ranking_screen')
    }, 1000)
  }

  handleBackToBase() {
    this.removeScreen()
  }

  handleKeyDown(e) {
    if (e.keyCode == 13) {
      e.preventDefault()
      return false
    }
  }

  displayButton(icon, action) {
    const { addHowlSound } = this.props

    return (
      <span
        className={icon}
        onClick={() => {
          action()
          addHowlSound('button_click_icon')
        }}
      ></span>
    )
  }

  searchUser(e) {
    const { searchUser } = this.props
    const elements = this.form

    e.preventDefault()
    e.stopPropagation()

    searchUser(elements['search'].value)
  }

  renderListUsers(user, position) {
    const {
      currentUser,
      connectedList,
      userMap,
      attackMap,
      isAttacking,
      endGameFlag,
      addPopup,
      setChatTarget,
      isTutorial,
      rankingObfuscated,
    } = this.props
    const connected =
      connectedList && connectedList.length ? connectedList.includes(user.licenseId) : false
    const isInBattle = currentUser.playersAttacked
      ? currentUser.playersAttacked[user.licenseId]
      : null

    if (user.cityLevel == undefined) {
      user.cityLevel = 1
    }
    let cityLevel = 'map.buildings.city_level.' + user.cityLevel
    let isActiveUser = currentUser.id == user.licenseId
    let classCurrentUser = isActiveUser ? 'active' : ''
    // let noBattleTag = (currentUser.batd == 0 ? 'battles.noMoreBattles' : 'battles.noMoreBattlePlayer')
    let endGame = endGameFlag
    let obfuscated = rankingObfuscated == 'undefined' ? 'normal' : rankingObfuscated
    let name =
      obfuscated == 'obfuscated'
        ? utils.obfuscated(user.name, currentUser)
        : obfuscated == 'alias'
        ? user.name == currentUser.name
          ? user.name
          : user.alias
        : user.name
    return (
      <div className={`mis--item ${connected ? 'online' : ''} ${classCurrentUser}`} key={position}>
        <div className="mis--item__info">
          <span className="position">{user.position}</span>
          <div className="icons">
            {!isTutorial && !isActiveUser && !endGame
              ? this.displayButton('icon-send', () => {
                  addPopup('chat_popup')
                  setChatTarget({ type: 'individual', id: user.licenseId })
                })
              : null}
            {!isActiveUser
              ? user.batp < 2 &&
                currentUser.batd < 2 &&
                !isInBattle &&
                !endGame &&
                Util.playerCanBeAttacked(userMap.buildings, user)
                ? this.displayButton('icon-desafio', () => {
                    !isAttacking ? attackMap() : null
                    this.handleLoadPlayer(user.licenseId)
                  })
                : this.displayButton('icon-visit', () => {
                    isAttacking ? attackMap() : null
                    this.handleLoadPlayer(user.licenseId)
                  })
              : endGame
              ? this.displayButton('icon-visit', () => {
                  this.handleLoadPlayer(user.licenseId)
                })
              : null}
          </div>
        </div>
        <div className="mis--item__info">
          <UserShield shield={user.colonyShield} />
          <div className="identity">
            <span className="text">{user.colonyName}</span>
            <span className="text">
              <FormattedMessage id={cityLevel} />
            </span>
            <span className="text">{name}</span>
            {user.federation ? <span className="text">{user.federation.name}</span> : null}
            <span className="num">
              <span className="icon-settlers"></span>
              {user.settlers}
            </span>
          </div>
        </div>
      </div>
    )
  }

  renderFilters() {
    const { changeFilter, addHowlSound, federationsInfo, isTutorial, endGameFlag } = this.props
    const { active } = this.state
    let endgame = endGameFlag
    return (
      <ul className="mis--tabs">
        {!isTutorial && federationsInfo && federationsInfo.federations ? (
          <li
            onClick={() => {
              this.setState({ active: 'federations', federationsTab: true })
            }}
            className={`mis--tabs__item ${active == 'federations' ? 'active' : ''}`}
          >
            <FormattedMessage id="ranking.federations" />
          </li>
        ) : null}
        <li
          onClick={() => {
            changeFilter('')
            this.setState({ federationsTab: false, active: 'all' })
            addHowlSound('button_click')
          }}
          className={`mis--tabs__item ${active == 'all' ? 'active' : ''}`}
        >
          <FormattedMessage id="ranking.all" />
        </li>
        <li
          onClick={() => {
            changeFilter('first')
            this.setState({ federationsTab: false, active: 'first' })
            addHowlSound('button_click')
          }}
          className={`mis--tabs__item ${active == 'first' ? 'active' : ''}`}
        >
          <FormattedMessage id="ranking.first" />
        </li>
        <li
          onClick={() => {
            changeFilter('last')
            this.setState({ federationsTab: false, active: 'last' })
            addHowlSound('button_click')
          }}
          className={`mis--tabs__item ${active == 'last' ? 'active' : ''}`}
        >
          <FormattedMessage id="ranking.last" />
        </li>
        <li
          onClick={() => {
            changeFilter('around')
            this.setState({ federationsTab: false, active: 'around' })
            addHowlSound('button_click')
          }}
          className={`mis--tabs__item ${active == 'around' ? 'active' : ''}`}
        >
          <FormattedMessage id="ranking.around" />
        </li>
        {!endgame && (
          <li
            onClick={() => {
              changeFilter('attackable')
              this.setState({ federationsTab: false, active: 'attackable' })
              addHowlSound('button_click')
            }}
            className={`mis--tabs__item ${active == 'attackable' ? 'active' : ''}`}
          >
            <FormattedMessage id="ranking.attackable" />
          </li>
        )}
      </ul>
    )
  }

  renderRanking() {
    const { ranking, currentUser, isTutorial, rankingTutorial } = this.props
    const { active } = this.state

    let voidMessage = null

    switch (active) {
      case 'attackable':
        voidMessage = (
          <div>
            {currentUser.batd >= 2 ? (
              <FormattedMessage id="ranking.attackWarning" />
            ) : (
              <FormattedMessage id="ranking.alreadyAttacked" />
            )}
          </div>
        )
        break
    }

    let rankingData = ranking
    if (isTutorial) {
      rankingData = rankingTutorial
    }

    return rankingData.length > 0
      ? rankingData.map((user, index) => this.renderListUsers(user, index + 1))
      : voidMessage
  }
  backToEndGame() {
    const { addScreen } = this.props
    this.closeScreen()
    addScreen('end_game')
  }

  closeScreen() {
    const { removeScreen } = this.props
    removeScreen('ranking_screen')
  }

  /**
   *  Render component
   */
  render() {
    const {
      changeFilter,
      firebasePath,
      currentUser,
      addHowlSound,
      gotoRanking,
      endGameFlag,
      intl,
    } = this.props
    const { growOutClass, federationsTab } = this.state
    let endgame = endGameFlag
    let endGameContainer = endgame ? 'background--mars' : 'background--mina'
    let rankingAnimation = endgame
      ? 'fadeInRight-animation'
      : !gotoRanking && !growOutClass
      ? 'growIn-animation'
      : gotoRanking
      ? 'fadeInLeft-animation'
      : ''
    /*{endgame && <div className='endgame--button'>
      <div className='btn--orange'>
        <span className='icon-rocket'></span>
        <span><FormattedMessage id='ranking.end'/> </span>
      </div>
    </div>}*/
    return (
      <div
        className={`container ${growOutClass} background ${endGameContainer} z-index1 ${rankingAnimation}`}
      >
        <div className="content">
          <BasicToast />
          <div className={`${endgame ? 'endgame' : ''} `}>
            {endgame && (
              <div className="position--absolute left center z-index1">
                <div
                  className="btn"
                  onClick={() => {
                    this.backToEndGame()
                  }}
                >
                  <div className="btn--primary">
                    <span className="icon-trophy"> </span>
                  </div>
                </div>
              </div>
            )}
            {endgame && (
              <div className="endgame--title">
                <FormattedMessage id="ranking.endgame" />{' '}
              </div>
            )}

            <div className={`${endgame ? 'endgame--layer ranking' : ''} `}>
              <div className={'mis'}>
                {!endgame && <MisHeader />}
                <div className="mis--body">
                  {!endgame && (
                    <Feed firebasePath={firebasePath} user={currentUser} visitUser={false} />
                  )}
                  {!endgame && <MapButton action={() => this.handleBackToBase()} />}
                  <div className="mis--content">
                    <form ref={(form) => (this.form = form)} className="search--game">
                      <input
                        className="input--search"
                        onClick={() => {
                          changeFilter('search')
                          this.setState({ federationsTab: false, active: 'all' })
                          addHowlSound('button_click')
                        }}
                        onKeyUp={(e) => this.searchUser(e)}
                        onKeyDown={(e) => this.handleKeyDown(e)}
                        type="text"
                        id="search"
                        name="search"
                        placeholder={intl.formatMessage({ id: 'ranking.searchPlaceHolder' })}
                      />
                    </form>
                    {this.renderFilters()}
                    <div className="mis--layer">
                      {federationsTab ? <Federations /> : this.renderRanking()}
                    </div>
                  </div>
                  {!endgame && (
                    <div
                      className="mis--challenges"
                      title={intl.formatMessage({ id: 'phase.tooltips.remainingBattles' })}
                    >
                      <span className="icon-desafio"></span>
                      <span className="number">{MAX_BATTLES - currentUser.batd}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  ranking: !tutorialSelectors.isTutorialMode(state) ? selectors.getFilteredRanking(state) : [],
  rankingTutorial: tutorialSelectors.getPlayerRanking(state),
  visitorMap: mapSelectors.getVisitorMap(state),
  firebasePath: Firebase.selectors.getFirebasePath(state),
  currentUser: tutorialSelectors.isTutorialMode(state)
    ? tutorialSelectors.getCurrentUser(state)
    : Firebase.selectors.getUserData(state),
  connectedList: Firebase.selectors.getConnectedPlayerList(state),
  federationsInfo: Firebase.selectors.getFederationsInfo(state),
  isAttacking: mapSelectors.getAttackState(state),
  gotoRanking: mapSelectors.getBackToRanking(state),
  userMap: !tutorialSelectors.isTutorialMode(state)
    ? mapSelectors.getUserMap(state)
    : tutorialSelectors.getUserMap(state),
  isTutorial: tutorialSelectors.isTutorialMode(state),
  endGameFlag: Firebase.selectors.getEndGameFlag(state),
  rankingObfuscated: Firebase.selectors.getObfuscatedRankingFlag(state),
})

const mapDispatchToProps = (dispatch) => ({
  changeFilter: bindActionCreators(actions.changeFilter, dispatch),
  addToast: bindActionCreators(toastManagerActions.addToast, dispatch),
  attackMap: bindActionCreators(mapActions.toggleAttack, dispatch),
  searchUser: bindActionCreators(actions.searchUser, dispatch),
  loadVisitorMap: bindActionCreators(mapActions.loadVisitorMap, dispatch),
  loadTutorialVisitorMap: bindActionCreators(tutorialActions.loadVisitorMap, dispatch),
  removeScreen: bindActionCreators(Game.actions.removeScreen, dispatch),
  addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
  removePopup: bindActionCreators(Game.actions.removePopup, dispatch),
  backToRanking: bindActionCreators(mapActions.backToRanking, dispatch),
  addScreen: bindActionCreators(Game.actions.addScreen, dispatch),
  setChatTarget: bindActionCreators(actions.setChatTarget, dispatch),
  addPopup: bindActionCreators(Game.actions.addPopup, dispatch),
})

RankingScreen.propTypes = {
  ranking: PropTypes.array,
  rankingTutorial: PropTypes.array,
  firebasePath: PropTypes.string,
  visitorMap: PropTypes.object,
  userMap: PropTypes.object,
  loadVisitorMap: PropTypes.func,
  loadTutorialVisitorMap: PropTypes.func,
  backToRanking: PropTypes.func,
  removePopup: PropTypes.func,
  isAttacking: PropTypes.bool,
  gotoRanking: PropTypes.bool,
  changeFilter: PropTypes.func,
  attackMap: PropTypes.func,
  removeScreen: PropTypes.func,
  searchUser: PropTypes.func,
  currentUser: PropTypes.object,
  connectedList: PropTypes.array,
  federationsInfo: PropTypes.object,
  addHowlSound: PropTypes.func,
  addScreen: PropTypes.func,
  addPopup: PropTypes.func,
  endGameFlag: PropTypes.bool,
  isTutorial: PropTypes.bool,
  setChatTarget: PropTypes.func,
  rankingObfuscated: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(RankingScreen))
